module.exports = __webpack_public_path__ + "static/img/slide-verify-01.e4984948.jpg";